import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { MessageModel } from 'src/app/shared/models/domain/message.model';
import { MessageSearchModel } from 'src/app/shared/models/domain/message-search.model';
import { ClientModel } from 'src/app/shared/models/domain/client.model';
import { tap } from 'rxjs/operators';

@Injectable()
export class MessageService {
  private url = environment.apiUrl + '/messages/';

  reloadMessages$ = new Subject();

  constructor(private http: HttpClient) {
  }

  listRecipients(businessKey: string): Observable<ClientModel[]> {
    return this.http.get<ClientModel[]>(`${this.url}recipients/business/${businessKey}`);
  }

  search(model: MessageSearchModel): Observable<MessageModel[]> {
    return this.http.post<MessageModel[]>(`${this.url}search`, model);
  }

  create(model: MessageModel): Observable<string> {
    return this.http.post<string>(`${this.url}`, model);
  }

  markAsRead(messageKey: string): Observable<boolean> {
    return this.http.put<boolean>(`${this.url}${messageKey}/read`, null).pipe(tap(_ => {
      this.reloadMessages$.next();
    }));
  }
}
